import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "section" }
const _hoisted_2 = { class: "container philosophy-grid" }
const _hoisted_3 = { class: "philosophy-copy dark-copy" }
const _hoisted_4 = { class: "values" }
const _hoisted_5 = { class: "section practice-values" }
const _hoisted_6 = { class: "container" }
const _hoisted_7 = { class: "home-features" }

import {Check, HeartHandshake, Microscope, ShieldCheck} from 'lucide-vue-next'
export default /*@__PURE__*/_defineComponent({
  __name: 'AboutView',
  setup(__props) {

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _cache[16] || (_cache[16] = _createElementVNode("section", { class: "page-hero" }, [
      _createElementVNode("div", { class: "container" }, [
        _createElementVNode("span", { class: "eyebrow" }, "Unsere Praxis"),
        _createElementVNode("h1", null, [
          _createTextVNode("Fachlich bestens versorgt."),
          _createElementVNode("br"),
          _createElementVNode("em", null, "Menschlich gut aufgehoben.")
        ]),
        _createElementVNode("p", null, "Eine ruhige Atmosphäre, moderne Behandlungsmethoden und Zeit für Ihre Fragen.")
      ])
    ], -1)),
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _cache[7] || (_cache[7] = _createElementVNode("div", { class: "practice-visual" }, [
          _createElementVNode("div", { class: "room-lines" }),
          _createElementVNode("span", { class: "experience" }, [
            _createElementVNode("strong", null, "30+"),
            _createElementVNode("small", null, [
              _createTextVNode("Jahre Erfahrung"),
              _createElementVNode("br"),
              _createTextVNode("in Musterstadt")
            ])
          ])
        ], -1)),
        _createElementVNode("div", _hoisted_3, [
          _cache[3] || (_cache[3] = _createElementVNode("span", { class: "eyebrow" }, "Unser Anspruch", -1)),
          _cache[4] || (_cache[4] = _createElementVNode("h2", null, "Wir betrachten nicht nur Zähne, sondern den ganzen Menschen.", -1)),
          _cache[5] || (_cache[5] = _createElementVNode("p", null, "Eine gute Mundgesundheit trägt wesentlich zum Wohlbefinden des gesamten Körpers bei. Deshalb planen wir jede Behandlung individuell und mit Blick auf langfristig stabile Ergebnisse.", -1)),
          _cache[6] || (_cache[6] = _createElementVNode("p", null, "Regelmäßige Fortbildungen und eine angenehme Praxisatmosphäre bilden die Basis für eine Versorgung, der Sie vertrauen können.", -1)),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("span", null, [
              _createVNode(_unref(Check)),
              _cache[0] || (_cache[0] = _createTextVNode(" Zeit für Ihre Fragen", -1))
            ]),
            _createElementVNode("span", null, [
              _createVNode(_unref(Check)),
              _cache[1] || (_cache[1] = _createTextVNode(" Individuelle Therapieplanung", -1))
            ]),
            _createElementVNode("span", null, [
              _createVNode(_unref(Check)),
              _cache[2] || (_cache[2] = _createTextVNode(" Substanzschonendes Vorgehen", -1))
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _cache[14] || (_cache[14] = _createElementVNode("span", { class: "eyebrow" }, "Was uns wichtig ist", -1)),
        _cache[15] || (_cache[15] = _createElementVNode("h2", { class: "standalone-title" }, "Qualität, die Sie spüren.", -1)),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", null, [
            _createVNode(_unref(HeartHandshake)),
            _cache[8] || (_cache[8] = _createElementVNode("h3", null, "Persönlichkeit", -1)),
            _cache[9] || (_cache[9] = _createElementVNode("p", null, "Wir hören zu, erklären verständlich und entscheiden gemeinsam.", -1))
          ]),
          _createElementVNode("div", null, [
            _createVNode(_unref(Microscope)),
            _cache[10] || (_cache[10] = _createElementVNode("h3", null, "Präzision", -1)),
            _cache[11] || (_cache[11] = _createElementVNode("p", null, "Sorgfältige Diagnostik und moderne Verfahren.", -1))
          ]),
          _createElementVNode("div", null, [
            _createVNode(_unref(ShieldCheck)),
            _cache[12] || (_cache[12] = _createElementVNode("h3", null, "Nachhaltigkeit", -1)),
            _cache[13] || (_cache[13] = _createElementVNode("p", null, "Unser Ziel ist der langfristige Erhalt Ihrer Mundgesundheit.", -1))
          ])
        ])
      ])
    ])
  ]))
}
}

})